import { render, staticRenderFns } from "./enclosureModel copy 2.vue?vue&type=template&id=2905b67b&scoped=true"
import script from "./enclosureModel copy 2.vue?vue&type=script&lang=js"
export * from "./enclosureModel copy 2.vue?vue&type=script&lang=js"
import style0 from "./enclosureModel copy 2.vue?vue&type=style&index=0&id=2905b67b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2905b67b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2905b67b')) {
      api.createRecord('2905b67b', component.options)
    } else {
      api.reload('2905b67b', component.options)
    }
    module.hot.accept("./enclosureModel copy 2.vue?vue&type=template&id=2905b67b&scoped=true", function () {
      api.rerender('2905b67b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/questionnaire/customerManage/questionnaireList/components/enclosureModel copy 2.vue"
export default component.exports